<template>
  <div class="chart-card">
    <div ref="targetChart" style="height: 430px; width: 100%; margin-top: 10px;"></div>
  </div>
</template>

<script>
import Highcharts from 'highcharts/es5/highcharts'
import mapInit from 'highcharts/es5/modules/map'
import brMap from '@/config/br-states.topo.json'
import ChartMix from '@/components/charts/ChartMix.vue'
import ChartThemeMixin from '@/components/charts/ChartThemeMixin.vue'
import { stateNamesByCode } from '@/constants/states'
import { buildTickPositions } from '@/models/heatmapLegend'

mapInit(Highcharts)
Highcharts.maps['brStates'] = brMap

const asCurrency = value => Highcharts.numberFormat(value || 0, 2, ',', '.')

export default {
  props: {
    graphData: { required: true, type: Array },
    graphTitle: { required: true, type: String },
    loading: { required: true, type: Boolean },
  },
  methods: {
    buildSeries() {
      return (this.graphData || [])
        .filter(item => item.uf)
        .map(item => {
          const count = item.count || 0
          const sum = (item.sum || 0) / 100

          return {
            'hc-a2': item.uf.toUpperCase(),
            ufName: stateNamesByCode[item.uf.toUpperCase()] || item.uf,
            count,
            sum,
            // estados sem multa ficam com value null -> pintados com nullColor (branco)
            value: count > 0 ? count : null
          }
        })
    },
    createChart() {
      if (!this.$refs.targetChart) return

      const existingChart = Highcharts.charts.find(chart =>
        chart && chart.renderTo === this.$refs.targetChart
      )
      if (existingChart)
        existingChart.destroy()

      this.$refs.targetChart.innerHTML = ''

      const theme = this.chartTheme
      const data = this.buildSeries()
      const max = Math.max(0, ...data.map(item => item.value || 0))

      Highcharts.mapChart(this.$refs.targetChart, {
        chart: {
          map: 'brStates',
          backgroundColor: theme.backgroundColor,
          style: { fontFamily: '"Montserrat", sans-serif' }
        },
        credits: { enabled: false },
        title: {
          text: this.currentTitle,
          align: 'center',
          style: {
            color: theme.textColor,
            fontSize: '18px',
            fontWeight: '600'
          }
        },
        mapNavigation: {
          enabled: true,
          buttonOptions: { verticalAlign: 'bottom' }
        },
        colorAxis: {
          min: 0,
          max: max || 1,
          startOnTick: false,
          endOnTick: false,
          tickPositions: buildTickPositions(max),
          stops: [
            [0, '#2ecc71'],
            [0.25, '#a3d94f'],
            [0.5, '#f1c40f'],
            [0.75, '#e67e22'],
            [1, '#e74c3c']
          ],
          labels: {
            style: { color: theme.textColor, fontWeight: '600' },
            formatter: function () {
              return Highcharts.numberFormat(this.value, 0, ',', '.')
            }
          }
        },
        legend: {
          enabled: max > 0,
          title: {
            text: 'Quantidade de Multas',
            style: { color: theme.textColor }
          },
          itemStyle: { color: theme.textColor }
        },
        tooltip: {
          backgroundColor: theme.backgroundColor,
          borderColor: theme.gridLineColor,
          style: { color: theme.textColor },
          useHTML: true,
          formatter: function () {
            const point = this.point
            const uf = point['hc-a2']
            const name = point.ufName || stateNamesByCode[uf] || uf

            return `<b>${name}</b><br/>` +
              `Quantidade: ${Highcharts.numberFormat(point.count || 0, 0, ',', '.')}<br/>` +
              `Valor: R$ ${asCurrency(point.sum)}`
          }
        },
        series: [{
          type: 'map',
          name: this.graphTitle,
          data,
          joinBy: ['hc-a2', 'hc-a2'],
          nullColor: '#ffffff',
          borderColor: theme.gridLineColor,
          dataLabels: {
            enabled: true,
            format: '{point.hc-a2}',
            // estados pequenos (ES, DF, SE, AL, RJ) só mostram a sigla sem crop/overlap
            crop: false,
            overflow: 'allow',
            allowOverlap: true,
            style: {
              color: theme.textColor,
              fontSize: '10px',
              fontWeight: '600',
              textOutline: 'none'
            }
          },
          states: {
            hover: { borderColor: theme.textColor }
          }
        }]
      })
    }
  },
  mixins: [ChartMix, ChartThemeMixin],
  mounted() {
    this.createChart()
  },
  watch: {
    isDarkTheme: {
      handler() {
        this.$nextTick(() => this.createChart())
      },
      immediate: false
    },
    graphData: {
      handler() {
        this.$nextTick(() => this.createChart())
      },
      deep: true
    }
  },
  name: 'CmFrotasMapChart'
}
</script>
